/*
  This example requires some changes to your config:
  
  ```
  // tailwind.config.js
  module.exports = {
    // ...
    plugins: [
      // ...
      require('@tailwindcss/aspect-ratio'),
    ],
  }
  ```
*/
import { Link } from "react-router-dom";
import ProgressBarForCard from "./ProgressBarForCard";
import { TrashIcon } from "@heroicons/react/24/outline";

export default function ProjectCard({ project, handleOpenState }) {
  return (
    <div
      className="cursor-pointer w-80 rounded-xl bg-slate-100 shadow-md"
      style={{ marginTop: "20px", marginBottom: "30px" }}
    >
      <Link to={`/dashboard/view-project/${project._id}`}>
        <div className="w-max h-max overflow-hidden rounded-t-xl aspect-h-1 aspect-w-2 group-hover:opacity-75 relative">
          <img
            src={project.thumbnail}
            alt="some-text"
            className="h-auto object-cover object-center"
          />
          <TrashIcon
            onClick={(event) => handleOpenState(event, project._id)}
            className="overflow-hidden h-7 w-7 bg-white absolute pl-2 pb-2 pr-1 hover:pl-4 hover:pb-4  hover:h-14 hover:w-14 duration-200"
            style={{ top: "0px", right: "0px", borderRadius: "0 0 0 80%" }}
          />
        </div>
        <ProgressBarForCard
          completed={project.completedVideos}
          total={project.totalvideos}
        />
        <p className="ml-2 text-lg font-semibold text-gray-900 my-2 max-w-full">
          {project.title}
        </p>
      </Link>
    </div>
  );
}
